<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printProductList('printProductList')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllProduct()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Product Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name2"
                label="Product Name2"
                type="text"
                v-model="queryParams.name2"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="brandName"
                label="Brand Name"
                type="text"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="categoryName"
                label="Category Name"
                type="text"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productGroupName"
                label="Product Group Name"
                type="text"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="productTypeList"
                label="Product Type"
                item-text="label"
                item-value="value"
                v-model="queryParams.productType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>
                  <v-btn
                    flat
                    icon
                    color="blue lighten-2"
                    @click.stop="onEdit(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-icon
                    v-if="props.item.status == 'ACTIVE'"
                    medium
                    color="green"
                    >check_circle</v-icon
                  >
                  <v-icon v-else medium color="red">cancel</v-icon>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.name2 }}</td>
                <td>
                  {{
                    props.item.code +
                    "/" +
                    props.item.brand.name +
                    "/" +
                    props.item.category.name
                  }}
                </td>
                <td v-if="props.item.productGroup">
                  {{ props.item.productGroup.name }}
                </td>
                <td v-else></td>
                <td>
                  {{
                    props.item.updatedDateInMilliSeconds
                      | format-ms-date-time
                  }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.productUnits"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">
                        {{
                          subprops.item.factor + "/" + subprops.item.unitName
                        }}
                      </td>
                      <td class="text-xs">{{ subprops.item.barcode }}</td>
                      <td class="text-xs">{{ subprops.item.unitCost }}</td>
                      <td class="text-xs">{{ subprops.item.sellingPrice }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <productExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></productExcel>
    <div
      id="printProductList"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Product List</p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Name</th>
              <th style="text-align: left">Name 2</th>
              <th style="text-align: left">Code/Brand/Category</th>
              <th style="text-align: left">Product Group</th>
              <th style="text-align: left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allproductList" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.name2 }}</td>
              <td>
                {{
                  item.code + "/" + item.brand.name + "/" + item.category.name
                }}
              </td>
              <td v-if="item.productGroup">{{ item.productGroup.name }}</td>
              <td v-else></td>
              <td>{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
        <div style="height: 10px"></div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { productService } from "../../services/product-service";
import productExcel from "../../components/product/ProductExcel";
import { commonService } from "../../services/common-service";

export default {
  name: "ProductList",

  components: { productExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Product Management",
        disabled: true,
      },
      {
        text: "Product",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Name", align: "left", value: "name" },
      { text: "Name2", align: "left", value: "name" },
      { text: "Code/Brand/Category/", value: "code" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],

    subHeaders: [
      { text: "Factor/Unit", sortable: false },
      { text: "Barcode", sortable: false },
      { text: "Unit Price", sortable: false },
      { text: "Selling Price", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0,
    },
    buttonLoading: false,
    productList: [],
    allproductList: [],
    openDialog: false,
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    productTypeList: [
      { label: "ALL", value: "" },
      { label: "STANDARD", value: "STANDARD" },
      { label: "PRODUCTION", value: "PRODUCTION" },
    ],
    queryParams: {
      name: "",
      name2: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      productType: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.brandName) {
      this.queryParams.brandName = this.$route.query.brandName;
    }
    if (this.$route.query.categoryName) {
      this.queryParams.categoryName = this.$route.query.categoryName;
    }
    if (this.$route.query.productGroupName) {
      this.queryParams.productGroupName = this.$route.query.productGroupName;
    }
    if (this.$route.query.productType) {
      this.queryParams.productType = this.$route.query.productType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "products", query: this.queryParams });
      this.getProductList();
    },
    printProductList(divName) {
      this.buttonLoading = true;
      productService
        .getAllProductList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allproductList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/product/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getProductList();
    },
    exportAllProduct() {
      this.buttonLoading = true;
      productService
        .getProductExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(()=>{
          this.buttonLoading = false;
        });
    },
    onEdit(product) {
      // go to details page
      this.$router.push("/product/" + product.id);
    },
  },
};
</script>